import { TablePage } from "~/components/Table";
import { LqsNavigation } from "~/lqs";
import { ObjectStoreFilters } from "./components/ObjectStoreFilters";
import {
  ObjectStoreSearchRequestProvider,
  ObjectStoreTable,
} from "./components/ObjectStoreTable";

export function ObjectStoresPage() {
  return (
    <TablePage
      title="Search Object Stores"
      navigation={<LqsNavigation />}
      RequestProvider={ObjectStoreSearchRequestProvider}
      table={<ObjectStoreTable />}
      filters={<ObjectStoreFilters />}
    />
  );
}
